import React from "react";
import { Outlet } from "react-router-dom";

const FullLayout = () => {
  return window.location === window.parent.location ? null : <Outlet />;
};

export default FullLayout;
